import * as Orientation from "utils/Orientation";
import { createSelector } from "reselect";

const getViewportHeight = (state) => state.viewport.dimensions.height;
const getViewportWidth = (state) => state.viewport.dimensions.width;

const getIsPortrait = createSelector(
  [getViewportHeight, getViewportWidth],
  (viewportHeight, viewportWidth) =>
    Orientation.isPortrait({
      height: viewportHeight,
      width: viewportWidth,
    }),
);

export default getIsPortrait;
